// Shared tesseract (4D hypercube) geometry used by TesseractLogo and InteractiveNetwork.

// 16 vertices of a tesseract at (±1, ±1, ±1, ±1)
export const TESSERACT_VERTICES = [];
for (let i = 0; i < 16; i++) {
    TESSERACT_VERTICES.push([
        (i & 1) ? 1 : -1,
        (i & 2) ? 1 : -1,
        (i & 4) ? 1 : -1,
        (i & 8) ? 1 : -1,
    ]);
}

// 32 edges: connect vertices that differ in exactly one coordinate
export const TESSERACT_EDGES = [];
for (let i = 0; i < 16; i++) {
    for (let j = i + 1; j < 16; j++) {
        const diff = i ^ j;
        if (diff === 1 || diff === 2 || diff === 4 || diff === 8) {
            TESSERACT_EDGES.push([i, j]);
        }
    }
}

// Rigid 3D rotation around Y, then X, then Z axes.
export function rotate3D(x, y, z, rotX, rotY, rotZ) {
    // Rotate around Y axis
    let cos = Math.cos(rotY), sin = Math.sin(rotY);
    let nx = x * cos - z * sin;
    let nz = x * sin + z * cos;
    x = nx; z = nz;

    // Rotate around X axis
    cos = Math.cos(rotX); sin = Math.sin(rotX);
    let ny = y * cos - z * sin;
    nz = y * sin + z * cos;
    y = ny; z = nz;

    // Rotate around Z axis
    cos = Math.cos(rotZ); sin = Math.sin(rotZ);
    nx = x * cos - y * sin;
    ny = x * sin + y * cos;
    x = nx; y = ny;

    return { x, y, z };
}

// Fixed 4D -> 3D perspective projection (creates the tesseract shape)
export function project4DTo3D(point4d, distance4d = 2.2) {
    const w = 1 / (distance4d - point4d[3]);
    return {
        x: point4d[0] * w,
        y: point4d[1] * w,
        z: point4d[2] * w,
    };
}

// Returns true when the user prefers reduced motion.
export function prefersReducedMotion() {
    return typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
